import React from "react";

const GlobalLoader = () => {
  return (
    <>
      <style>
        {`
        .gl-overlay {
          position: fixed;
          inset: 0;
          backdrop-filter: blur(4px);
          background: rgba(0, 0, 0, 0.45);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
          animation: gl-fadeIn 0.2s ease;
        }

        .gl-box {
          text-align: center;
          animation: gl-scaleIn 0.3s ease;
        }

        .gl-logo {
          width: 110px;
          height: auto;
          animation: gl-pulse 1.8s infinite ease-in-out;
        }

        .gl-spinner {
          margin: 18px auto 0 auto;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          animation: gl-spin 0.75s linear infinite;
        }

        /* Animations */
        @keyframes gl-spin {
          to { transform: rotate(360deg); }
        }

        @keyframes gl-pulse {
          0%, 100% {
            opacity: 0.4;
            transform: scale(0.92);
          }
          50% {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes gl-fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes gl-scaleIn {
          from { transform: scale(0.9); opacity: 0.7; }
          to { transform: scale(1); opacity: 1; }
        }
      `}
      </style>

      <div className="gl-overlay">
        <div className="gl-box">
          <img
            src="/assets/images/logo.png"
            alt="Loading"
            className="gl-logo"
          />
          {/* <div className="gl-spinner"></div> */}
        </div>
      </div>
    </>
  );
};

export default GlobalLoader;
